import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import { Organization } from "astrid-firestore/src/api/organizations/types/Organization";
import { updateDocument } from "astrid-firestore/src/helpers/index";

import PrimaryButton from "../../../ui/components/Buttons/PrimaryButton";

import featureFlags from "../../../authorization/constants/featureFlags";
import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";

export default function PublisherSettings({ organization }) {
	const { t } = useTranslation();

	const form = useSimpleForm({
		schema: Organization,
		defaultValues: {
			featureFlags: organization.featureFlags || [],
			cloudStartFeesFrom: organization.cloudStartFeesFrom?.toDate?.() || null,
		},
		onSubmit: async ({ featureFlags, cloudStartFeesFrom }) => {
			await updateDocument(organization.ref, { featureFlags, cloudStartFeesFrom: cloudStartFeesFrom || null });
		},
	});

	const { formState, onSubmit } = form;

	return (
		<>
			<Header as="h3">{t("settings", "Settings")}</Header>

			<Card fluid>
				<Card.Content>
					<Form form={form}>
						<Form.Select
							name="featureFlags"
							label="Feature flags"
							options={[
								{
									key: featureFlags.FLATTENING,
									value: featureFlags.FLATTENING,
									text: "Enable production migration",
								},
								{
									key: featureFlags.DISCUSSION,
									value: featureFlags.DISCUSSION,
									text: "Enable new discussion",
								},
							]}
							rules={{ required: false }}
							multiple
						/>

						<Form.DateInput
							name="cloudStartFeesFrom"
							label={t("cloudStartFeesFrom", "Charge cloud start fees for works created from")}
							rules={{ required: false }}
						/>

						<p style={{ marginTop: 8, opacity: 0.7 }}>
							{t(
								"cloudStartFeesFromDescription",
								"Leave empty to never charge this publisher cloud start fees.",
							)}
						</p>
					</Form>
				</Card.Content>

				<Card.Content>
					<PrimaryButton
						disabled={formState.isSubmitting || !formState.isDirty}
						loading={formState.isSubmitting}
						onClick={onSubmit}
					>
						{t("save", "Save")}
					</PrimaryButton>
				</Card.Content>
			</Card>
		</>
	);
}
